import React, { useEffect } from 'react';
import { instance } from '../../common';

function CheckCart({ u_id, cartData, setCartData, cartLength, setCartLength }) {
  let obj = {
    u_id: u_id,
  };

  useEffect(() => {
    const fetchData = async () => {
      instance.post('/cart/my_cart', obj).then(function (res) {
        setCartLength(res.data.length);
        setCartData(res.data);
      });
    };

    fetchData();
  }, []);

  const count = {
    position: 'absolute',
    top: 0,
    right: '-3px',
    color: '#fff',
    background: 'red',
    width: '16px',
    textAlign: 'center',
    fontSize: '11px',
    borderRadius: '90px',
  };

  return (
    <>
      {cartLength > 0 ? <span style={count}>{cartLength}</span> : <span></span>}
    </>
  );
}

export default CheckCart;
